/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
export type BillingAccountFragment = {
  readonly __typename: 'BillingAccount';
  readonly id: string;
  readonly description: string;
  readonly nickname: string | null;
  readonly isDefault: boolean;
  readonly cardType: Types.CardType;
  readonly expirationState: Types.ExpirationState;
};

export type AddressFragment = {
  readonly __typename?: 'Address';
  readonly id: string;
  readonly street: string;
  readonly secondaryStreet: string | null;
  readonly name: string | null;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly country: string;
  readonly deliveryPreference: Types.DeliveryPreferenceType;
  readonly googlePlaceId: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly notes: string | null;
};

export type CustomerCreditsFragment = {
  readonly __typename?: 'Credit';
  readonly id: string;
  readonly title: string;
  readonly description: string | null;
  readonly amount: number;
  readonly remainingAmount: number;
  readonly createdAt: string;
  readonly expiresAt: string | null;
};

export type CustomerDataFragment = {
  readonly __typename?: 'Customer';
  readonly id: string;
  readonly trackingUuid: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly phoneNumber: string | null;
  readonly email: string | null;
  readonly qrCode: string;
  readonly useCredit: boolean;
  readonly availableCredit: number;
  readonly addresses: ReadonlyArray<{
    readonly __typename?: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly name: string | null;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly country: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly notes: string | null;
  }>;
  readonly billingAccounts: ReadonlyArray<{
    readonly __typename: 'BillingAccount';
    readonly id: string;
    readonly description: string;
    readonly nickname: string | null;
    readonly isDefault: boolean;
    readonly cardType: Types.CardType;
    readonly expirationState: Types.ExpirationState;
  }>;
  readonly credits: ReadonlyArray<{
    readonly __typename?: 'Credit';
    readonly id: string;
    readonly title: string;
    readonly description: string | null;
    readonly amount: number;
    readonly remainingAmount: number;
    readonly createdAt: string;
    readonly expiresAt: string | null;
  }>;
};

export const AddressFragmentDoc = gql`
  fragment address on Address {
    id
    street
    secondaryStreet
    name
    city
    state
    zipCode
    country
    deliveryPreference
    googlePlaceId
    latitude
    longitude
    notes
  }
`;
export const BillingAccountFragmentDoc = gql`
  fragment billingAccount on BillingAccount {
    __typename
    id
    description
    nickname
    isDefault
    cardType
    expirationState
  }
`;
export const CustomerCreditsFragmentDoc = gql`
  fragment customerCredits on Credit {
    id
    title
    description
    amount
    remainingAmount
    createdAt
    expiresAt
  }
`;
export const CustomerDataFragmentDoc = gql`
  fragment CustomerData on Customer {
    id
    trackingUuid
    firstName
    lastName
    phoneNumber
    email
    qrCode
    addresses {
      ...address
    }
    billingAccounts {
      ...billingAccount
    }
    useCredit
    availableCredit
    credits {
      ...customerCredits
    }
  }
  ${AddressFragmentDoc}
  ${BillingAccountFragmentDoc}
  ${CustomerCreditsFragmentDoc}
`;
